/* theme.deals.js — split verbatim from Shrine main.js (deobfuscated 2026-10-14).
   Load order: theme.core → theme.cart → theme.search → theme.product → theme.deals → theme.extras → theme.license-guard. */

class BundleDeals extends HTMLElement {
  constructor() {
    super();
    this.productContainers = this.querySelectorAll(".bundle-deals__product-js");
    this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js");
    this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js");
    this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js");
    this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js");
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.prices = this.querySelectorAll(".bundle-deals__price-js");
    this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js");
    this.totalPrice = this.querySelector(".bundle-deals__total-price-js");
    this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.percentageLeft = parseFloat(this.dataset.percentageLeft);
    this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
    this.currencySymbol = this.dataset.currencySymbol;
    this.selectedVariants = {
      id_1: null,
      id_2: null,
      id_3: null,
      id_4: null,
      id_5: null
    };
    this.formVariants = [];
    this.initIds();
    this.checkboxes.forEach(item => {
      item.addEventListener("change", this.handleCheckboxChange.bind(this));
    });
    this.variantPickers.forEach(item => {
      item.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  initIds() {
    this.checkboxes.forEach(item => {
      this.selectedVariants[item.dataset.idIndex] = {
        id: item.dataset.id,
        price: item.dataset.price,
        comparePrice: item.dataset.comparePrice,
        checked: true
      };
    });
    this.updateFormIds();
  }
  handleCheckboxChange(event) {
    const target = event.currentTarget,
      isChecked = target.checked,
      parseIntResult = parseInt(target.dataset.index);
    this.selectedVariants[target.dataset.idIndex].checked = isChecked;
    const item = this.productContainers[parseIntResult],
      els = item.querySelectorAll("select");
    isChecked ? (this.mediaItemContainers[parseIntResult].classList.remove("bundle-deals__media-item--disabled"), item.classList.remove("bundle-deals__product--deselected"), els.forEach(item2 => {
      item2.removeAttribute("disabled");
    })) : (this.mediaItemContainers[parseIntResult].classList.add("bundle-deals__media-item--disabled"), item.classList.add("bundle-deals__product--deselected"), els.forEach(item2 => {
      item2.setAttribute("disabled", "");
    }));
    this.updateFormIds();
    if (this.updatePrices) this.updateTotalPrice();
  }
  handleSelectChange(event) {
    const target = event.currentTarget,
      parseIntResult = parseInt(target.dataset.index),
      list = Array.from(target.querySelectorAll("select"), arg => arg.value),
      filtered = JSON.parse(target.querySelector("[type=\"application/json\"]").textContent).filter(item => target.querySelector(":checked").value === item.option1),
      arr = [...target.querySelectorAll(".select--small")];
    updateVariantStatuses(filtered, arr, this.skipUnavailable);
    const found = JSON.parse(target.querySelector("[type=\"application/json\"]").textContent).find(item => {
      return !item.options.map((item2, index) => {
        return list[index] === item2;
      }).includes(false);
    });
    if (!found) {
      if (this.skipNonExistent) findAvailableVariant(target, list, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !found.available) {
      if (findAvailableVariant(target, list, false, true, true)) return;
    }
    let {
      price: value,
      compare_at_price: value2,
      featured_image: value3
    } = found;
    value = parseInt(value);
    let parseIntResult2 = value2 ? parseInt(value2) : value;
    const percentageLeft = target.dataset.percentageLeft ?? 1,
      fixedDiscount = target.dataset.fixedDiscount ?? 0;
    value = value * percentageLeft - fixedDiscount;
    if (value3) value3 = value3.src;
    const id = found.id;
    this.selectedVariants[target.dataset.idIndex].id = id;
    this.selectedVariants[target.dataset.idIndex].price = value;
    this.selectedVariants[target.dataset.idIndex].comparePrice = parseIntResult2;
    this.updateFormIds();
    this.updatePrices && (this.prices[parseIntResult].innerHTML = this.currencySymbol + (value / 100).toFixed(2), parseIntResult2 > value ? this.comparePrices[parseIntResult].innerHTML = this.currencySymbol + (parseIntResult2 / 100).toFixed(2) : this.comparePrices[parseIntResult].innerHTML = "", this.updateTotalPrice());
    value3 && value3.length > 0 && this.mediaItemImgs[parseIntResult] && (this.mediaItemImgs[parseIntResult].src = value3);
  }
  updateFormIds() {
    const arr = [],
      selectedVariants = this.selectedVariants;
    for (const value in selectedVariants) {
      const item = selectedVariants[value];
      if (item != null && item.checked) {
        const index = arr.findIndex(item2 => item2.id === item.id);
        index < 0 ? arr.unshift({
          id: item.id,
          quantity: 1
        }) : arr[index].quantity += 1;
      }
    }
    this.formVariants = arr;
  }
  updateTotalPrice() {
    const arr = [],
      arr2 = [],
      selectedVariants = this.selectedVariants;
    for (const value2 in selectedVariants) {
      const item = selectedVariants[value2];
      item != null && item.checked && (arr.push(parseInt(item.price)), arr2.push(parseInt(item.comparePrice)));
    }
    const reduce = arr.reduce((acc, item) => acc + item, 0),
      value = reduce * this.percentageLeft - this.fixedDiscount,
      reduce2 = arr2.reduce((acc, item) => acc + item, 0);
    this.totalPrice.innerHTML = this.currencySymbol + (value / 100).toFixed(2);
    reduce2 > value ? this.totalComparePrice.innerHTML = this.currencySymbol + (reduce2 / 100).toFixed(2) : this.totalComparePrice.innerHTML = "";
  }
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.quantityBreakUpsells = this.querySelectorAll("quantity-break-upsells");
    this.subscriptionWidget = document.getElementById("SubscriptionWidget-" + this.dataset.section);
    this.inputs = this.querySelectorAll("input[name=\"quantity\"]");
    this.labels = this.querySelectorAll(".quantity-break");
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.hasVariants = this.jsonData.dataset.hasVariants === "true";
    this.selectedVariants = {
      input_1: [],
      input_2: [],
      input_3: [],
      input_4: [],
      input_5: [],
      input_6: []
    };
    this.updateUnavailable = this.dataset.updateUnavailable === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.formVariants = [];
    this.selectedQuantity = 1;
    this.selectedOffer = 1;
    const el = this.querySelector("input[checked]");
    el && (this.selectedQuantity = parseInt(el.value), this.selectedOffer = parseInt(el.dataset.input.replace("input_", "")));
    this.variantSelects = this.querySelectorAll(".quantity-break__selector-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.updatePdpPrices = this.dataset.updatePdpPrices === "true";
    this.moneyFormat = this.dataset.moneyFormat;
    this.subDiscount = 0;
    this.subDiscountType = null;
    this.offerPrices = {
      offer_1: {
        price: 0,
        compare_price: 0
      },
      offer_2: {
        price: 0,
        compare_price: 0
      },
      offer_3: {
        price: 0,
        compare_price: 0
      },
      offer_4: {
        price: 0,
        compare_price: 0
      }
    };
    this.initOfferPrices();
    if (this.dataset.currencyConversion === "true") {
      const _qbGetPresentmentRateResult = _qbGetPresentmentRate(this.dataset.shopCurrency);
      _qbGetPresentmentRateResult && (this.labels.forEach(item => {
        item.dataset.fixedDiscount && (item.dataset.fixedDiscount = String(Math.round(parseFloat(item.dataset.fixedDiscount) * _qbGetPresentmentRateResult)));
      }), this.initOfferPrices());
    }
    this.preventGalleryScroll = this.dataset.preventGalleryScroll === "true";
    if (this.hasVariants) this.initVariants();
    this.inputs.forEach(item => {
      item.addEventListener("change", this.handleChange.bind(this));
    });
    this.variantSelects.forEach(item => {
      item.addEventListener("change", this.handleSelectChange.bind(this));
    });
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== "unit") {
      if (this.subscriptionWidget.renderSubTexts) this.subscriptionWidget.renderSubTexts();
    }
  }
  applySubTo(arg) {
    if (!this.subDiscountType || !arg) return arg;
    if (this.subDiscountType === "fixed_amount") return Math.max(0, arg - this.subDiscount);else {
      if (this.subDiscountType === "percentage") return Math.round(arg * (100 - this.subDiscount) / 100);else {
        if (this.subDiscountType === "price") return this.subDiscount;
      }
    }
    return arg;
  }
  initOfferPrices() {
    const parseIntResult = parseInt(this.dataset.basePrice);
    this.labels.forEach(item => {
      const replaced = item.dataset.input.replace("input_", ""),
        parseIntResult2 = parseInt(item.dataset.quantity),
        parseFloatResult = parseFloat(item.dataset.percentageLeft),
        parseFloatResult2 = parseFloat(item.dataset.fixedDiscount),
        value = parseIntResult * parseIntResult2 * parseFloatResult - parseFloatResult2,
        parseIntResult3 = parseInt(item.dataset.baseComparePrice),
        value2 = parseIntResult3 * parseIntResult2;
      this.offerPrices["offer_" + replaced].price = value;
      this.offerPrices["offer_" + replaced].compare_price = value2;
    });
    if (this.updatePdpPrices) this.updateDisplayedPdpPrices();
  }
  updateInnerPrices() {
    this.labels.forEach(item => {
      const replaced = item.dataset.input.replace("input_", ""),
        parseFloatResult = parseFloat(item.dataset.quantity),
        applySubTo = this.applySubTo(this.offerPrices["offer_" + replaced].price),
        compare_price = this.offerPrices["offer_" + replaced].compare_price;
      this.updateLabelPrices(item, parseFloatResult, applySubTo, compare_price);
    });
  }
  updateLabelPrices(el, arg, arg2, arg3) {
    const value = arg3 - arg2,
      value2 = Math.round(value / 100) * 100,
      value3 = arg2 / arg,
      value4 = arg3 / arg,
      formattedPrice = formatMoney(arg2, this.moneyFormat, true),
      formattedPrice2 = formatMoney(arg3, this.moneyFormat, true),
      formattedPrice3 = formatMoney(value, this.moneyFormat, true),
      formattedPrice4 = formatMoney(value2, this.moneyFormat, true),
      formattedPrice5 = formatMoney(value3, this.moneyFormat, true),
      formattedPrice6 = formatMoney(value4, this.moneyFormat, true);
    el.querySelectorAll(".variant-price-update").forEach(item => {
      let text = item.dataset.text;
      text = text.replace("[quantity]", arg);
      text = text.replace("[price]", formattedPrice);
      text = text.replace("[compare_price]", formattedPrice2);
      text = text.replace("[amount_saved]", formattedPrice3);
      text = text.replace("[amount_saved_rounded]", formattedPrice4);
      text = text.replace("[price_each]", formattedPrice5);
      text = text.replace("[compare_price_each]", formattedPrice6);
      item.innerHTML = text;
    });
    const el2 = el.querySelector(".quantity-break__compare-price");
    el2 && (arg3 > arg2 ? el2.classList.remove("hidden") : el2.classList.add("hidden"));
  }
  updateDisplayedPdpPrices() {
    const applySubTo = this.applySubTo(this.offerPrices["offer_" + this.selectedOffer].price),
      compare_price = this.offerPrices["offer_" + this.selectedOffer].compare_price;
    updatePdpPrices(applySubTo, compare_price, this.dataset.section, this.moneyFormat);
  }
  handleSelectChange(event) {
    const target = event.currentTarget,
      list = Array.from(target.querySelectorAll("select"), arg => arg.value);
    if (this.updateUnavailable) {
      const filtered = this.getVariantData().filter(item => target.querySelector(":checked").value === item.option1),
        arr = [...target.querySelectorAll(".select--small")];
      updateVariantStatuses(filtered, arr, this.skipUnavailable);
    }
    const found = this.getVariantData().find(item => {
      return !item.options.map((item2, index) => {
        return list[index] === item2;
      }).includes(false);
    });
    if (!found) {
      if (this.skipNonExistent) findAvailableVariant(target, list, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !found.available) {
      if (findAvailableVariant(target, list, false, true, true)) return;
    }
    target.dataset.selectedId = found.id;
    const selectIndex = target.dataset.selectIndex,
      parentEl = target.closest(".quantity-break"),
      input = parentEl.dataset.input;
    this.selectedVariants[input][selectIndex] = found.id;
    this.formVariants = this.selectedVariants[input];
    if (!this.preventGalleryScroll) this.updateMedia(found);
    const el = target.querySelector(".quantity-break__selector-item__image img");
    if (el) el.src = found.featured_image.src;
    if (!this.updatePrices) return;
    var num = 0,
      num2 = 0;
    const parseFloatResult = parseFloat(parentEl.dataset.quantity),
      parseFloatResult2 = parseFloat(parentEl.dataset.percentageLeft),
      parseFloatResult3 = parseFloat(parentEl.dataset.fixedDiscount);
    var flag = true;
    if (parentEl.dataset.compareMode === "price") flag = false;
    for (let num3 = 0; num3 < parseFloatResult; num3++) {
      const parseIntResult = parseInt(this.selectedVariants[input][num3]),
        found2 = this.getVariantData().find(item => parseInt(item.id) === parseIntResult);
      if (!found2) return;
      num += found2.price;
      found2.compare_at_price && flag && found2.compare_at_price > found2.price ? num2 += found2.compare_at_price : num2 += found2.price;
    }
    num = num * parseFloatResult2 - parseFloatResult3;
    this.offerPrices["offer_" + this.selectedOffer].price = num;
    this.offerPrices["offer_" + this.selectedOffer].compare_price = num2;
    num = this.applySubTo(num);
    this.updateLabelPrices(parentEl, parseFloatResult, num, num2);
    if (this.updatePdpPrices) this.updateDisplayedPdpPrices();
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== "unit") {
      if (this.subscriptionWidget.renderSubTexts) this.subscriptionWidget.renderSubTexts();
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
  initVariants() {
    if (!this.hasVariants) return;
    this.labels.forEach(item => {
      if (item.querySelector(".quantity-break__variants")) {
        let arr = [];
        item.querySelectorAll(".quantity-break__selector-item").forEach(item2 => {
          arr.push(item2.dataset.selectedId);
        });
        this.selectedVariants[item.dataset.input] = arr;
      }
    });
    this.formVariants = [];
  }
  updateMedia(arg) {
    if (!arg) return;
    if (!arg.featured_media) return;
    const els = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    els.forEach(item => {
      if (item.setActiveMedia) item.setActiveMedia(this.dataset.section + "-" + arg.featured_media.id, true);
    });
  }
  handleChange(arg) {
    const parseIntResult = parseInt(arg.target.value);
    this.selectedQuantity = parseIntResult;
    this.selectedOffer = parseInt(arg.target.dataset.input.replace("input_", ""));
    if (this.hasVariants) this.formVariants = this.selectedVariants[arg.target.dataset.input];
    if (this.quantityGifts) this.quantityGifts.unlockGifts(parseIntResult);
    this.quantityBreakUpsells.forEach(item => {
      item.initUnlock();
    });
    if (this.updatePdpPrices) this.updateDisplayedPdpPrices();
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== "unit") {
      if (this.subscriptionWidget.renderSubTexts) this.subscriptionWidget.renderSubTexts();
    }
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
class ShrineSubscriptionWidget extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.productForm = document.getElementById("product-form-" + this.sectionId);
    this.isCheckbox = this.dataset.isCheckbox === "true";
    this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.oneTimeBox = this.querySelector("[data-type=\"one_time\"]");
    this.oneTimeBoxTexts = this.querySelectorAll(".one-time-price-update");
    this.subscriptionBox = this.querySelector("[data-type=\"subscription\"]");
    this.frequencySelect = this.querySelector(".subscription__select .select__select");
    this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input");
    this.subBoxTexts = this.querySelectorAll(".sub-price-update");
    this.selectedPlanId = this.dataset.firstSellingPlanId;
    this.isSubSelected = this.dataset.preselected === "subscription";
    this.sellingPlanInput = null;
    this.subscriptionName = this.dataset.subscriptionName;
    this.basePrice = parseInt(this.dataset.basePrice);
    this.baseComparePrice = parseInt(this.dataset.baseComparePrice);
    this.updatePrices = this.dataset.updatePrices === "true";
    this.discountType = this.dataset.discountType;
    this.discountValue = parseInt(this.dataset.discountValue);
    this.displayedPrices = this.dataset.displayedPrices || "unit";
    this.moneyFormat = this.dataset.moneyFormat;
    this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.quantityBreaks && (this.quantityBreaks.updatePrices = true, this.quantityBreaks.updatePdpPrices = true);
    if (this.updatePrices) this.updateAllPrices();
    this.init();
    this.displayedPrices !== "unit" && this.quantityBreaks && this.quantityBreaks.offerPrices && (this.updatePricesFromQtyBreaks = true, this.renderSubTexts());
  }
  init() {
    this.createSellingPlanInput();
    this.setupBoxClickListeners();
    this.setupFrequencyListeners();
  }
  createSellingPlanInput() {
    this.sellingPlanInput = document.createElement("input");
    this.sellingPlanInput.type = "hidden";
    this.sellingPlanInput.name = "selling_plan";
    this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : "";
    if (this.productForm) this.productForm.appendChild(this.sellingPlanInput);
  }
  setupBoxClickListeners() {
    [this.oneTimeBox, this.subscriptionBox].forEach(item => {
      if (!item) return;
      item.addEventListener("click", event => {
        if (this.isCheckbox && event.target.closest(".subscription__frequency")) return;
        if (this.isCheckbox) {
          const contains = item.classList.contains("subscription__box--selected");
          this.isSubSelected = !contains;
          item.classList.toggle("subscription__box--selected");
          item.dataset.selected = !contains;
          this.sellingPlanInput.value = !contains ? this.selectedPlanId : "";
        } else {
          this.isSubSelected = item.dataset.type === "subscription";
          this.oneTimeBox?.["classList"]["remove"]("subscription__box--selected");
          this.subscriptionBox?.["classList"]["remove"]("subscription__box--selected");
          this.oneTimeBox?.["setAttribute"]("data-selected", "false");
          this.subscriptionBox?.["setAttribute"]("data-selected", "false");
          item.classList.add("subscription__box--selected");
          item.dataset.selected = "true";
          this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : "";
        }
        if (this.updatePrices) this.updateAllPrices();
      });
    });
  }
  updateAllPrices() {
    this.basePrice = parseInt(this.dataset.basePrice);
    this.baseComparePrice = parseInt(this.dataset.baseComparePrice);
    if (this.quantityBreaks) {
      this.isSubSelected ? (this.quantityBreaks.subDiscountType = this.discountType, this.quantityBreaks.subDiscount = this.discountValue) : (this.quantityBreaks.subDiscountType = null, this.quantityBreaks.subDiscount = 0);
      this.quantityBreaks.updateDisplayedPdpPrices();
      this.quantityBreaks.updateInnerPrices();
    } else {
      let applySubTo = this.applySubTo(this.basePrice);
      updatePdpPrices(applySubTo, this.baseComparePrice, this.dataset.section, this.moneyFormat);
    }
    const el = document.querySelector("variant-selects[data-section=\"" + this.sectionId + "\"][data-has-quantity-breaks-picker=\"true\"]");
    el && el.updateQuantityBreaksPickerPrices && el.updateQuantityBreaksPickerPrices(this.isSubSelected ? this.discountType : null, this.isSubSelected ? this.discountValue : 0, this.moneyFormat);
    this.renderSubTexts();
  }
  applySubTo(arg, arg2 = false) {
    if (this.isSubSelected || arg2) {
      if (this.discountType === "fixed_amount") return Math.max(0, arg - this.discountValue);else {
        if (this.discountType === "percentage") return Math.round(arg * (100 - this.discountValue) / 100);else {
          if (this.discountType === "price") return this.discountValue;
        }
      }
    }
    return arg;
  }
  setupFrequencyListeners() {
    this.frequencyRadios.forEach(item => {
      item.addEventListener("change", event => {
        this.applyFrequencyNode(event.currentTarget);
      });
    });
    this.frequencySelect && this.frequencySelect.addEventListener("change", () => {
      const value = this.frequencySelect.selectedOptions?.[0];
      if (value) this.applyFrequencyNode(value);
    });
  }
  applyFrequencyNode(el) {
    this.selectedPlanId = el.dataset.sellingPlanId;
    this.discountType = el.dataset.discountType || this.discountType;
    this.discountValue = el.dataset.discountValue ? parseInt(el.dataset.discountValue, 10) : this.discountValue;
    this.subscriptionBox?.["classList"]["contains"]("subscription__box--selected") && (this.sellingPlanInput.value = this.selectedPlanId || "");
    if (this.updatePrices) this.updateAllPrices();
  }
  computeSubPrices(arg = true) {
    let basePrice = this.basePrice,
      baseComparePrice = this.baseComparePrice;
    this.quantityBreaks && this.displayedPrices !== "unit" && (basePrice = this.quantityBreaks.offerPrices["offer_" + this.quantityBreaks.selectedOffer].price, baseComparePrice = this.quantityBreaks.offerPrices["offer_" + this.quantityBreaks.selectedOffer].compare_price, this.displayedPrices == "unit_with_discount" && (basePrice = basePrice / this.quantityBreaks.selectedQuantity, baseComparePrice = baseComparePrice / this.quantityBreaks.selectedQuantity));
    if (arg) basePrice = this.applySubTo(basePrice, true);
    let subscriptionName = this.subscriptionName;
    const max = Math.max(0, baseComparePrice - basePrice),
      value = Math.round(max / 100) * 100,
      round = baseComparePrice > 0 ? Math.round(max * 100 / baseComparePrice) : 0;
    return {
      price: basePrice,
      comparePrice: baseComparePrice,
      amount_saved: max,
      amount_saved_rounded: value,
      percentage_saved: round,
      subscription_name: subscriptionName
    };
  }
  renderSubTexts() {
    if (this.subBoxTexts.length > 0) {
      const {
        price: computeSubPrices,
        compare_price: computeSubPrices2,
        amount_saved: computeSubPrices3,
        amount_saved_rounded: computeSubPrices4,
        percentage_saved: computeSubPrices5,
        subscription_name: computeSubPrices6
      } = this.computeSubPrices();
      this.updatePriceTexts(this.subBoxTexts, computeSubPrices, computeSubPrices2, computeSubPrices3, computeSubPrices4, computeSubPrices5, computeSubPrices6);
    }
    if (this.updatePricesFromQtyBreaks) this.renderOneTimeTexts();
  }
  renderOneTimeTexts() {
    if (this.oneTimeBoxTexts.length > 0) {
      const {
        price: computeSubPrices,
        compare_price: computeSubPrices2,
        amount_saved: computeSubPrices3,
        amount_saved_rounded: computeSubPrices4,
        percentage_saved: computeSubPrices5,
        subscription_name: computeSubPrices6
      } = this.computeSubPrices(false);
      this.updatePriceTexts(this.oneTimeBoxTexts, computeSubPrices, computeSubPrices2, computeSubPrices3, computeSubPrices4, computeSubPrices5, computeSubPrices6);
    }
  }
  updatePriceTexts(arg, arg2, arg3, arg4, arg5, arg6, arg7) {
    const callback = arg8 => formatMoney(arg8, this.moneyFormat, true);
    arg.forEach(item => {
      let text = item.dataset.text || "";
      text = text.replaceAll("[price]", callback(arg2)).replaceAll("[compare_price]", callback(arg3)).replaceAll("[amount_saved]", callback(arg4)).replaceAll("[amount_saved_rounded]", callback(arg5)).replaceAll("[percentage_saved]", String(arg6) + "%").replaceAll("[subscription_name]", arg7 || "");
      item.innerHTML = text;
      item.classList.contains("subscription__compare-price") && item.classList.toggle("hidden", !(arg3 > arg2));
    });
  }
  hydrateFromExternalHTML(el) {
    const callback = el4 => {
        const el5 = el4.querySelector(".subscription__select .select__select"),
          els = el4.querySelectorAll(".subscription__frequency-input");
        if (el5) return {
          type: "select",
          count: el5.options.length,
          index: el5.selectedIndex >= 0 ? el5.selectedIndex : 0
        };
        if (els.length) {
          const index = Array.from(els).findIndex(item => item.checked);
          return {
            type: "radio",
            count: els.length,
            index: index >= 0 ? index : 0
          };
        }
        return {
          type: "none",
          count: 0,
          index: 0
        };
      },
      callbackResult = callback(this),
      isSubSelected = this.isSubSelected;
    this.dataset.firstSellingPlanId = el.dataset.firstSellingPlanId ?? "";
    this.dataset.subscriptionName = el.dataset.subscriptionName ?? "";
    this.dataset.discountType = el.dataset.discountType ?? "";
    this.dataset.discountValue = el.dataset.discountValue ?? "0";
    const el2 = el.querySelector(".subscription__wrapper"),
      el3 = this.querySelector(".subscription__wrapper");
    if (el2 && el3) el3.replaceWith(el2);
    this.oneTimeBox = this.querySelector("[data-type=\"one_time\"]");
    this.oneTimeBoxTexts = this.querySelectorAll(".one-time-price-update");
    this.subscriptionBox = this.querySelector("[data-type=\"subscription\"]");
    this.subBoxTexts = this.querySelectorAll(".sub-price-update");
    this.frequencySelect = this.querySelector(".subscription__select .select__select");
    this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input");
    const callbackResult2 = callback(this);
    let num = 0;
    callbackResult.type !== "none" && callbackResult2.type !== "none" && callbackResult.count === callbackResult2.count && (num = Math.max(0, Math.min(callbackResult.index, callbackResult2.count - 1)));
    if (callbackResult2.type === "select" && this.frequencySelect) this.frequencySelect.selectedIndex = num;else callbackResult2.type === "radio" && this.frequencyRadios.length && this.frequencyRadios.forEach((item, index) => {
      item.checked = index === num;
    });
    let value = null;
    if (this.frequencySelect) value = this.frequencySelect.selectedOptions?.[0] || this.frequencySelect.options?.[0] || null;else this.frequencyRadios.length && (value = Array.from(this.frequencyRadios).find(item => item.checked) || this.frequencyRadios[0]);
    this.selectedPlanId = value?.["dataset"]["sellingPlanId"] || this.dataset.firstSellingPlanId || "";
    value ? this.applyFrequencyNode(value) : (this.selectedPlanId = this.dataset.firstSellingPlanId || "", this.discountType = this.dataset.discountType || "", this.discountValue = parseInt(this.dataset.discountValue || "0", 10));
    isSubSelected && this.subscriptionBox ? (this.subscriptionBox.classList.add("subscription__box--selected"), this.subscriptionBox.setAttribute("data-selected", "true"), this.oneTimeBox?.["classList"]["remove"]("subscription__box--selected"), this.oneTimeBox?.["setAttribute"]("data-selected", "false"), this.isSubSelected = true, this.sellingPlanInput.value = this.selectedPlanId || "") : (this.subscriptionBox?.["classList"]["remove"]("subscription__box--selected"), this.subscriptionBox?.["setAttribute"]("data-selected", "false"), this.oneTimeBox && (this.oneTimeBox.classList.add("subscription__box--selected"), this.oneTimeBox.setAttribute("data-selected", "true")), this.isSubSelected = false, this.sellingPlanInput.value = "");
    this.setupBoxClickListeners();
    this.setupFrequencyListeners();
    this.updatePrices ? this.updateAllPrices() : this.renderSubTexts();
  }
}
customElements.define("shrine-subscription-widget", ShrineSubscriptionWidget);
class QuantityGifts extends HTMLElement {
  constructor() {
    super();
    this.gifts = this.querySelectorAll(".quantity-gift");
    this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section);
    this.unlockedItems = [];
    this.mainProduct = this.dataset.mainProduct;
    this.cartItems = document.querySelector("cart-drawer-items");
    this.unlockBy = this.dataset.unlockBy === "variant" ? "variant" : "quantity";
    this.initUnlock();
    this.saveLocalStorage = this.dataset.saveLocalStorage === "true";
    if (this.saveLocalStorage && this.unlockBy !== "variant") this.storeLocalStorageData();
  }
  connectedCallback() {
    if (this.unlockBy !== "variant") return;
    this._variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, ({
      data: arg
    }) => {
      if (!arg || arg.sectionId !== this.dataset.section) return;
      this.unlockGiftsByVariant(arg.variant, false);
    });
  }
  disconnectedCallback() {
    this._variantUnsub && (this._variantUnsub(), this._variantUnsub = undefined);
  }
  storeLocalStorageData() {
    this.gifts.forEach(item => {
      updateGiftGoalInStorage({
        giftHandle: item.dataset.handle,
        giftVariantId: item.dataset.product,
        unlockType: "product_quantity",
        unlockRequirement: item.dataset.quantity,
        unlockTarget: this.mainProduct
      });
    });
  }
  initUnlock() {
    if (this.unlockBy === "variant") {
      const _readCurrentVariant = this._readCurrentVariant();
      this.unlockGiftsByVariant(_readCurrentVariant, true);
      return;
    }
    let num = 1;
    const els = this.mainProduct ? document.querySelectorAll(".cart-item--product-" + this.mainProduct) : null;
    if (els && els.length) {
      num = 0;
      for (let num2 = 0; num2 < els.length; num2++) {
        num += parseInt(els[num2].dataset.quantity);
      }
    } else {
      if (this.quantityBreaks) num = parseInt(this.quantityBreaks.selectedQuantity);else {
        if (this.quantitySelector) {
          const el = this.quantitySelector.querySelector("input[name=\"quantity\"]");
          num = parseInt(el.value);
        }
      }
    }
    this.unlockGifts(num, true);
  }
  unlockGifts(arg, arg2 = false) {
    if (this.unlockBy === "variant") return;
    this.unlockedItems = [];
    this.gifts.forEach(item => {
      if (parseInt(item.dataset.quantity) <= arg) {
        item.classList.add("quantity-gift--unlocked");
        item.dataset.unlocked = "true";
        const el = document.querySelector(".cart-item--product-" + item.dataset.handle);
        if (item.dataset.product && !el) this.unlockedItems.unshift(item.dataset.product);
      } else {
        item.classList.remove("quantity-gift--unlocked");
        item.dataset.unlocked = "false";
      }
    });
    if (this.mainProduct && arg2) this.addRemoveProducts();
  }
  _readCurrentVariant() {
    const el = document.querySelector("variant-selects[data-section=\"" + this.dataset.section + "\"]");
    if (!el) return null;
    if (el.currentVariant) return el.currentVariant;
    const arr = [];
    el.querySelectorAll(".product-form__input").forEach(item => {
      const el2 = item.querySelector(".product-form__input__type"),
        type = el2 ? el2.dataset.type : null;
      let value;
      if (type === "dropdown" || type === "dropdwon") {
        const el3 = item.querySelector(".select__select");
        value = el3 ? el3.value : undefined;
      } else {
        const el3 = item.querySelector("input[type=\"radio\"]:checked");
        value = el3 ? el3.value : undefined;
      }
      if (value !== undefined) arr.push(value);
    });
    try {
      const el2 = el.querySelector("[type=\"application/json\"]");
      if (!el2) return null;
      const data = JSON.parse(el2.textContent);
      return data.find(item => Array.isArray(item.options) && item.options.length === arr.length && item.options.every((item2, index) => item2 === arr[index])) || null;
    } catch (error) {
      return null;
    }
  }
  _getOptionOrders() {
    const el = document.querySelector("variant-selects[data-section=\"" + this.dataset.section + "\"]");
    if (!el) return null;
    try {
      const el2 = el.querySelector("[type=\"application/json\"]");
      if (!el2) return null;
      const data = JSON.parse(el2.textContent),
        obj = {
          option1: [],
          option2: [],
          option3: []
        };
      data.forEach(item => {
        ["option1", "option2", "option3"].forEach(item2 => {
          const item3 = item[item2];
          if (item3 !== null && item3 !== undefined) {
            const text = String(item3).toLowerCase().trim();
            !obj[item2].includes(text) && obj[item2].push(text);
          }
        });
      });
      return obj;
    } catch (error) {
      return null;
    }
  }
  unlockGiftsByVariant(arg, arg2 = false) {
    this.unlockedItems = [];
    if (!arg) {
      this.gifts.forEach(item => {
        item.classList.remove("quantity-gift--unlocked");
        item.dataset.unlocked = "false";
        this.saveLocalStorage && removeLocalStorageGift({
          gift_handle: item.dataset.handle
        });
      });
      if (this.mainProduct && arg2) this.addRemoveProducts();
      return;
    }
    const _getOptionOrders = this._getOptionOrders(),
      obj = {
        option1: arg.option1 ? String(arg.option1).toLowerCase().trim() : null,
        option2: arg.option2 ? String(arg.option2).toLowerCase().trim() : null,
        option3: arg.option3 ? String(arg.option3).toLowerCase().trim() : null
      };
    this.gifts.forEach(item => {
      const text = (item.dataset.variant || "").toLowerCase().trim();
      if (!text.length) {
        item.classList.remove("quantity-gift--unlocked");
        item.dataset.unlocked = "false";
        this.saveLocalStorage && removeLocalStorageGift({
          gift_handle: item.dataset.handle
        });
        return;
      }
      let flag = false,
        arr = [];
      if (_getOptionOrders) for (const value of ["option1", "option2", "option3"]) {
        const item2 = _getOptionOrders[value],
          index = item2.indexOf(text);
        if (index === -1) continue;
        const item3 = obj[value],
          index2 = item3 ? item2.indexOf(item3) : -1;
        index2 >= index && (flag = true, arr = item2.slice(index));
        break;
      }
      if (!_getOptionOrders) {
        const mapped = [arg.title, arg.option1, arg.option2, arg.option3, ...(Array.isArray(arg.options) ? arg.options : [])].filter(item2 => item2 !== undefined && item2 !== null).map(item2 => String(item2).toLowerCase().trim());
        flag = mapped.includes(text);
        arr = [text];
      }
      if (flag) {
        item.classList.add("quantity-gift--unlocked");
        item.dataset.unlocked = "true";
        const el = document.querySelector(".cart-item--product-" + item.dataset.handle);
        if (item.dataset.product && !el) this.unlockedItems.unshift(item.dataset.product);
        this.saveLocalStorage && updateGiftGoalInStorage({
          giftHandle: item.dataset.handle,
          giftVariantId: item.dataset.product,
          unlockType: "product_variant",
          unlockRequirement: arr,
          unlockTarget: this.mainProduct
        });
      } else {
        item.classList.remove("quantity-gift--unlocked");
        item.dataset.unlocked = "false";
        this.saveLocalStorage && removeLocalStorageGift({
          gift_handle: item.dataset.handle
        });
      }
    });
    if (this.mainProduct && arg2) this.addRemoveProducts();
  }
  addRemoveProducts() {
    if (!this.mainProduct) return;
    const els = document.querySelectorAll(".cart-item--product-" + this.mainProduct);
    this.gifts.forEach(item => {
      els.length ? item.dataset.unlocked === "true" && item.dataset.product ? this.addToCart(item) : this.removeFromCart(item) : this.removeFromCart(item);
    });
  }
  addToCart(el) {
    const el2 = document.querySelector(".cart-item--product-" + el.dataset.handle);
    if (el2) return;
    const el3 = el.querySelector("product-form");
    if (el3 && el3.handleSubmit) el3.handleSubmit();
  }
  removeFromCart(el) {
    const el2 = document.querySelector(".cart-item--product-" + el.dataset.handle);
    if (!el2 || !this.cartItems) return;
    this.cartItems.updateQuantity(el2.dataset.index, 0);
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class QuantityBreakUpsells extends QuantityGifts {
  constructor() {
    super();
    this.offerIndex = this.dataset.offer;
    this.upsells = this.querySelectorAll(".quantity-break__upsell");
    this.boundToggleHandler = this.handleToggle.bind(this);
    this.upsells.forEach(item => {
      item.dataset.toggle === "true" && item.addEventListener("click", this.boundToggleHandler);
    });
    this.initUnlock();
    if (this.saveLocalStorage) this.storeLocalStorageData();
  }
  storeLocalStorageData() {
    if (!this.upsells) return;
    this.upsells.forEach(item => {
      if (item.dataset.type !== "gift") return;
      updateGiftGoalInStorage({
        giftHandle: item.dataset.handle,
        giftVariantId: item.dataset.product,
        unlockType: "product_quantity",
        unlockRequirement: item.dataset.minQuantity,
        unlockTarget: this.dataset.mainProduct
      });
    });
  }
  disconnectedCallback() {
    this.upsells.forEach(item => {
      item.dataset.toggle === "true" && item.removeEventListener("click", this.boundToggleHandler);
    });
  }
  unlockGifts(arg, arg2 = false) {
    this.unlockedItems = [];
    if (!this.upsells) return;
    this.upsells.forEach(item => {
      const parseIntResult = parseInt(item.dataset.minQuantity || 0),
        value = arg >= parseIntResult,
        value2 = item.dataset.selected === "true",
        value3 = value && value2;
      item.dataset.unlocked = value3.toString();
      item.classList.toggle("quantity-gift--unlocked", value3);
      const el = document.querySelector(".cart-item--product-" + item.dataset.handle);
      if (value3 && item.dataset.product && !el) {
        const value4 = item.dataset.toggle === "true",
          value5 = item.dataset.selected === "true";
        (!value4 || value4 && value5) && this.unlockedItems.unshift(item.dataset.product);
      }
    });
    if (this.mainProduct && arg2) {
      if (this.dataset.lastOffer === this.dataset.offer) this.addRemoveProducts();
    }
  }
  addRemoveProducts() {
    if (!this.mainProduct) return;
    const els = document.querySelectorAll(".cart-item--product-" + this.mainProduct),
      arr = [],
      arr2 = [];
    this.upsells.forEach(item => {
      const el = document.querySelector(".cart-item--product-" + item.dataset.handle),
        value = item.dataset.unlocked === "true";
      if (els.length) {
        if (value && !el) arr.push(item);else !value && el && arr2.push(item);
      } else el && arr2.push(item);
    });
    if (arr2.length) this.removeFromCart(arr2[0]);else arr.length && this.addToCart(arr[0]);
  }
  handleToggle(event) {
    const target = event.currentTarget,
      value = target.dataset.selected === "true";
    target.dataset.selected = (!value).toString();
    this.syncUpsellAcrossOffers(target.dataset.handle, !value);
    this.syncCart(target.dataset.handle, !value, target);
  }
  syncUpsellAcrossOffers(arg, arg2) {
    const els = document.querySelectorAll("quantity-break-upsells");
    els.forEach(item => {
      item.querySelectorAll(".quantity-break__upsell[data-handle=\"" + arg + "\"]").forEach(item2 => {
        item2.dataset.selected = arg2.toString();
      });
    });
  }
  syncCart(arg, arg2, arg3) {
    const el = document.querySelector(".cart-item--product-" + arg);
    if (!this.cartItems) return;
    if (arg2 && !el) this.addToCart(arg3);else !arg2 && el && this.removeFromCart(arg3);
  }
}
customElements.define("quantity-break-upsells", QuantityBreakUpsells);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector(".upsell__image__img");
    this.toggleBtn = this.querySelector(".upsell-toggle-btn");
    this.variantSelects = this.querySelector(".upsell__variant-picker");
    this.variantSelectElements = this.querySelectorAll(".select__select");
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.productForm = this.querySelector("product-form");
    if (this.productForm) this.idInput = this.productForm.querySelector("[name=\"id\"]");
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.price = parseInt(this.dataset.price);
      this.comparePrice = parseInt(this.dataset.comparePrice);
      this.priceSpan = this.querySelector(".upsell__price .regular-price");
      this.comparePriceSpan = this.querySelector(".upsell__price .compare-price");
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
      this.isMainOfferItem = this.dataset.mainOfferItem === "true";
      if (this.isMainOfferItem) this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section);
    }
    if (this.toggleBtn) this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
    if (this.variantSelects) this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
  }
  handleToggle(arg) {
    if (arg.target.nodeName.toLowerCase() === "select" || arg.target.nodeName.toLowerCase() === "option") return;
    this.dataset.selected === "true" ? this.dataset.selected = "false" : this.dataset.selected = "true";
  }
  handleSelectChange(event) {
    const target = event.currentTarget,
      list = Array.from(target.querySelectorAll("select"), arg => arg.value),
      found = this.getVariantData().find(item => {
        return !item.options.map((item2, index) => {
          return list[index] === item2;
        }).includes(false);
      }),
      filtered = this.getVariantData().filter(item => target.querySelector(":checked").value === item.option1),
      arr = [...target.querySelectorAll("select")];
    updateVariantStatuses(filtered, arr, this.skipUnavailable);
    if (!found) {
      if (this.skipNonExistent) findAvailableVariant(target, list, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !found.available) {
      if (findAvailableVariant(target, list, false, true, true)) return;
    }
    this.updatePrices && (this.price = found.price * this.percentageLeft - this.fixedDiscount, this.comparePrice = found.price, found.compare_at_price && found.compare_at_price > found.price && (this.comparePrice = found.compare_at_price), displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat));
    if (this.image && found.featured_image) this.image.src = found.featured_image.src;
    this.updateId(found.id);
    if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices) this.mainOfferContainer.updateTotalPrices();
  }
  updateId(arg) {
    this.dataset.id = arg;
    if (this.idInput) this.idInput.value = arg;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartItems = this.cartDrawer ? this.cartDrawer.querySelector("cart-drawer-items") : null;
    this.classicAddButton = this.querySelector(".upsell__add-btn");
  }
  handleToggle(arg) {
    if (arg.target.nodeName.toLowerCase() === "select" || arg.target.nodeName.toLowerCase() === "option") return;
    this.dataset.selected === "true" ? (this.dataset.selected = "false", this.removeFromCart()) : (this.dataset.selected = "true", this.addToCart());
  }
  addRemoveFromCart() {
    this.dataset.selected === "true" && !this.cartDrawer.classList.contains("is-empty") ? this.addToCart() : this.removeFromCart();
  }
  addToCart() {
    const el = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (el) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute("disabled", "");
    this.variantSelectElements.forEach(item => {
      item.setAttribute("disabled", "");
    });
    this.productForm.handleSubmit();
  }
  removeFromCart() {
    const el = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (!el || !this.cartItems) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute("disabled", "");
    this.variantSelectElements.forEach(item => {
      item.setAttribute("disabled", "");
    });
    this.cartItems.updateQuantity(el.dataset.index, 0);
  }
  updateId(arg) {
    this.dataset.id = arg;
    this.idInput.value = arg;
    if (this.classicAddButton) return;
    if (this.dataset.selected === "true") {
      this.selectTimeout && clearTimeout(this.selectTimeout);
      this.removeFromCart();
      const callback = event => {
        event.detail.handle === "handle" && (this.addToCart(), document.removeEventListener("cartQuantityUpdated", callback));
      };
      document.addEventListener("cartQuantityUpdated", callback);
    }
  }
  getUpdateRequired() {
    const el = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    let flag = false;
    if (el && this.dataset.selected === "false") flag = true;else !el && this.dataset.selected === "true" && (flag = true);
    return flag;
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
    this.saveLocalStorage = this.dataset.saveLocalStorage === "true";
    if (this.saveLocalStorage) this.storeLocalStorageData();
  }
  storeLocalStorageData() {
    if (!this.dataset.handle || !this.dataset.id || !this.dataset.mainProduct || !this.dataset.requirement || !this.dataset.type) return;
    updateGiftGoalInStorage({
      giftHandle: this.dataset.handle,
      giftVariantId: this.dataset.id,
      unlockType: this.dataset.type,
      unlockRequirement: Number(this.dataset.requirement),
      unlockTarget: this.dataset.mainProduct
    });
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
  const el = document.querySelector("cart-drawer");
  el && el.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(item => {
    if (item.addRemoveFromCart) item.addRemoveFromCart();
  });
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super();
    this.offerItems = this.querySelectorAll(".main-offer-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.updatePrices && (this.priceSpan = this.querySelector(".bundle-deals__total-price-js"), this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js"), this.percentageLeft = parseFloat(this.dataset.percentageLeft), this.fixedDiscount = parseFloat(this.dataset.fixedDiscount), this.moneyFormat = this.dataset.moneyFormat);
  }
  updateTotalPrices() {
    if (!this.updatePrices) return;
    var num = 0,
      num2 = 0;
    for (let num3 = 0; num3 < this.offerItems.length; num3++) {
      num += parseInt(this.offerItems[num3].price);
      num2 += parseInt(this.offerItems[num3].comparePrice);
    }
    num = num * this.percentageLeft - this.fixedDiscount;
    displayPrices(num, num2, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
